// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs-carousel":"Breadcrumbs_breadcrumbs-carousel__7VoWU","breadcrumbs-carousel--rightAlign":"Breadcrumbs_breadcrumbs-carousel--rightAlign__eU7Bm"};